import React from 'react';

const StatsSection = ({ items = [] }) => {
    const colClass = items.length === 3 ? 'col-12 col-md-6 col-xl-4' : 'col-12 col-md-6 col-xl-3';

    return (
        <div className="mxd-section padding-pre-grid my-4 my-md-5 py-3 py-md-4">
            <div className="mxd-container">
                <div className="container-fluid px-0">
                    <div className="row gx-4 gy-4 text-center">
                        {items.map((item, index) => (
                            <div key={index} className={colClass}>
                                <div className="anim-uni-in-up">
                                    <h3 className="mxd-stats-number small" style={{ marginBottom: '1rem' }}>
                                        {item.value}
                                    </h3>
                                    <p className="t-bright" style={{ fontSize: '2rem' }}>{item.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StatsSection;
